<template>
  <div class="businesList">
    <div
      class="businesaccount"
      v-for="account in accountList"
      :key="account.id"
    >
      <div class="businessaccountinfo">
        <div class="businessaccountinfop">
          <p>نام:</p>
          <p>
            {{ account.name }}
          </p>
        </div>
        <div class="businessaccountinfop">
          <p>وضعیت:</p>
          <p v-if="account.active">فعال</p>
          <p v-else>غیر فعال</p>
        </div>
        <div class="businessaccountinfop">
          <p>تایید شده :</p>
          <p v-if="account.verify">بله</p>
          <p v-else>خیر</p>
        </div>
      </div>
      <img class="businessaccount-img" :src="apiAdder + account.avatar" />
    </div>
    <button class="m-btn add-btn2" @click="createAccountHandler">
      اتصال حساب جدید
    </button>
  </div>
</template>
<script>
import "vueperslides/dist/vueperslides.css";
import "vue3-carousel/dist/carousel.css";
export default {
  props: {
    accountList: [],
  },
  data() {
    return {
      accountCardList: [],
      apiAdder: process.env.VUE_APP_API,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    createAccountHandler() {
      this.$emit("creat");
    },
  },
};
</script>
<style scoped>
.businesaccount {
  background: #ddd;
  border-radius: 20px;
  margin-top: 10px;
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  align-items: center;
}
.businesList {
  width: 80%;
}
.businessaccount-img {
  width: 20px;
  height: 20px;
  border-radius: 20px;
}
.businessaccountinfo {
}
.businessaccountinfop {
  display: flex;
  direction: rtl;
}
.add-btn2 {
  margin-top: 10px;
}
</style>
